<template>
  <div class="base-layout" :class="{'fixed-header':scrollTop>116}">
    <base-header/>
    <base-main/>
    <base-footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import BaseHeader from '@/components/layout/BaseHeader.vue'
import BaseMain from '@/components/layout/BaseMain.vue'
import BaseFooter from '@/components/layout/BaseFooter.vue'

export default {
  name: 'base-layout',
  components: {
    BaseHeader,
    BaseMain,
    BaseFooter
  },
  data: function () {
    return {
      scrollTop: 0
    }
  },
  created() {
    window.onscroll = () => {
      this.scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    }
  }
}
</script>
